// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* New Note Button */
.new-note-btn {
  display: flex;
  width: 100%;
  cursor: pointer;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  border-radius: 0.75rem;
  height: 2.75rem;
  background-color: var(--text-muted);
  color: white;
  gap: 0.5rem;
  box-shadow: var(--shadow-md);
  transition: opacity var(--transition-fast);
  border: none;
  font-family: inherit;
}

.new-note-btn:hover {
  opacity: 0.9;
}

.new-note-btn:focus-visible {
  outline: 2px solid var(--text-primary);
  outline-offset: 2px;
}

.btn-label {
  font-size: 1rem;
  line-height: 1.5rem;
  font-weight: 600;
}

.btn-icon {
  font-size: 20px;
}

/* Theme Toggle Button */
.theme-toggle-btn {
  width: 2.25rem;
  height: 2.25rem;
  border-radius: 9999px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--text-muted);
  transition: background-color var(--transition-fast);
  background: transparent;
  border: none;
  cursor: pointer;
}

.theme-toggle-btn:hover {
  background-color: rgba(0, 0, 0, 0.05);
}

.dark .theme-toggle-btn:hover {
  background-color: rgba(255, 255, 255, 0.1);
}

.theme-toggle-btn:focus-visible {
  outline: 2px solid var(--text-muted);
  outline-offset: 2px;
}

/* Theme Icons */
.theme-icon {
  font-size: 20px;
}

.theme-icon.light {
  display: block;
}

.theme-icon.dark {
  display: none;
}

.dark .theme-icon.light {
  display: none;
}

.dark .theme-icon.dark {
  display: block;
}

/* Mobile Theme Toggle Button */
.mobile-theme-toggle-btn {
  width: 2.5rem;
  height: 2.5rem;
  border-radius: var(--radius-full);
  display: flex;
  align-items: center;
  justify-content: center;
  border: 2px solid var(--input-border);
  background: transparent;
  cursor: pointer;
}

.mobile-theme-toggle-btn .theme-icon {
  color: var(--text-muted);
}

.mobile-theme-toggle-btn:focus-visible {
  outline: 2px solid var(--text-muted);
  outline-offset: 2px;
}
`, "",{"version":3,"sources":["webpack://./src/styles/components/buttons.css"],"names":[],"mappings":"AAAA,oBAAoB;AACpB;EACE,aAAa;EACb,WAAW;EACX,eAAe;EACf,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,sBAAsB;EACtB,eAAe;EACf,mCAAmC;EACnC,YAAY;EACZ,WAAW;EACX,4BAA4B;EAC5B,0CAA0C;EAC1C,YAAY;EACZ,oBAAoB;AACtB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,sCAAsC;EACtC,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA,wBAAwB;AACxB;EACE,cAAc;EACd,eAAe;EACf,qBAAqB;EACrB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,wBAAwB;EACxB,mDAAmD;EACnD,uBAAuB;EACvB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,oCAAoC;EACpC,mBAAmB;AACrB;;AAEA,gBAAgB;AAChB;EACE,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA,+BAA+B;AAC/B;EACE,aAAa;EACb,cAAc;EACd,iCAAiC;EACjC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,qCAAqC;EACrC,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,oCAAoC;EACpC,mBAAmB;AACrB","sourcesContent":["/* New Note Button */\n.new-note-btn {\n  display: flex;\n  width: 100%;\n  cursor: pointer;\n  align-items: center;\n  justify-content: center;\n  overflow: hidden;\n  border-radius: 0.75rem;\n  height: 2.75rem;\n  background-color: var(--text-muted);\n  color: white;\n  gap: 0.5rem;\n  box-shadow: var(--shadow-md);\n  transition: opacity var(--transition-fast);\n  border: none;\n  font-family: inherit;\n}\n\n.new-note-btn:hover {\n  opacity: 0.9;\n}\n\n.new-note-btn:focus-visible {\n  outline: 2px solid var(--text-primary);\n  outline-offset: 2px;\n}\n\n.btn-label {\n  font-size: 1rem;\n  line-height: 1.5rem;\n  font-weight: 600;\n}\n\n.btn-icon {\n  font-size: 20px;\n}\n\n/* Theme Toggle Button */\n.theme-toggle-btn {\n  width: 2.25rem;\n  height: 2.25rem;\n  border-radius: 9999px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: var(--text-muted);\n  transition: background-color var(--transition-fast);\n  background: transparent;\n  border: none;\n  cursor: pointer;\n}\n\n.theme-toggle-btn:hover {\n  background-color: rgba(0, 0, 0, 0.05);\n}\n\n.dark .theme-toggle-btn:hover {\n  background-color: rgba(255, 255, 255, 0.1);\n}\n\n.theme-toggle-btn:focus-visible {\n  outline: 2px solid var(--text-muted);\n  outline-offset: 2px;\n}\n\n/* Theme Icons */\n.theme-icon {\n  font-size: 20px;\n}\n\n.theme-icon.light {\n  display: block;\n}\n\n.theme-icon.dark {\n  display: none;\n}\n\n.dark .theme-icon.light {\n  display: none;\n}\n\n.dark .theme-icon.dark {\n  display: block;\n}\n\n/* Mobile Theme Toggle Button */\n.mobile-theme-toggle-btn {\n  width: 2.5rem;\n  height: 2.5rem;\n  border-radius: var(--radius-full);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border: 2px solid var(--input-border);\n  background: transparent;\n  cursor: pointer;\n}\n\n.mobile-theme-toggle-btn .theme-icon {\n  color: var(--text-muted);\n}\n\n.mobile-theme-toggle-btn:focus-visible {\n  outline: 2px solid var(--text-muted);\n  outline-offset: 2px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
